<template>
    <div :style="{height:innerHeight-314+'px'}">
        <div class="blank40"/>
        <div class="blank40"/>
        <div class="blank40"/>
        <ActiveCourse style="width:350px;margin:auto" :level="Number(userInfo.type)+1" :which="'course'"/>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import ActiveCourse from '../registerAndLogin/components/registerStep5'
export default {
    data() {
        return {
            innerHeight:''
        }
    },
    computed:mapState([
        'userInfo'
    ]),
    components:{
        ActiveCourse
    },
    mounted() {
        this.innerHeight = window.innerHeight;
    },
}
</script>
